import { render, staticRenderFns } from "./bo-shipping-method-select.vue?vue&type=template&id=bd6d8664"
import script from "./bo-shipping-method-select.vue?vue&type=script&lang=js"
export * from "./bo-shipping-method-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports